module.exports = __webpack_public_path__ + "static/media/faded-bars-background.8514a735.png";